import { NgModule } from '@angular/core';

import {
    HisAuthGuard, HisBootstrapService, HisUiService,
    HisGlobalDataService, HisGenericValueService
} from 'hisng';

import { PersonSharedModule } from './person-shared.module';
import { PersonRoutesModule } from './person.routes';
import { PersonService } from '../common/service/person.service';
import { PersonProfileEntryService } from './service/personprofile-entry.service';

/**
 * CoreModule for persons.
 */
@NgModule( {
    imports: [
        PersonSharedModule,
        PersonRoutesModule
    ],
    declarations: [],
    exports: [PersonSharedModule],
    providers: [
        HisUiService,
        HisGenericValueService,
        PersonService,
        PersonProfileEntryService
    ],
} )

export class PersonCoreModule {
}
